import React, {useEffect} from "react";
import {getObjectByPath, uniqueId} from "../../../utils";
import {  variableCurrencyValue } from '../../../components/field-table';
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { Ambient } from "../../../generated/graphql";
import {RegionTypeSelect} from "../../../components/MaterialSelects/RegionTypeSelect";
import {AmbientTypeSelect} from "../../../components/MaterialSelects/AmbientTypeSelect";
import {IsoDatePicker} from "../../../components/IsoDatePicker";
import {CurrencyField} from "../../../components/CurrencyInput";
import {FieldTable} from "../../../components/FieldTable/FieldTable";
import {RegionSelect} from "../../../components/MaterialSelects/RegionSelect";
import {useOutletContext} from "react-router-dom";
import {CampaignOutletContextValue} from "../form";


const newRow = ()=> ({
  campaignComponent: {
    region:null,
    regionType:null,
    unit_value_local: '',
    qty: ''
  },
  ambientType: null,
  id: uniqueId(),
  start_date: null,
  end_date: null,
  name: ''
});

const summaries = {
  footer: (old, newRow) => { return !newRow; }
}

// eslint-disable-next-line react/display-name
const AmbientPane = React.memo(() => {
  const { values, errors, setValue, loading,readOnly,setTab,isReadOnly } = useOutletContext<CampaignOutletContextValue>();

  const columns:FieldTableColumnProps<Ambient>[] = [
    {
      header: 'Region Type',
      accessor: 'campaignComponent.regionType',
      sort: 'campaignComponent.regionType.name',
      dataType:'select',
      options: {
        label:'name',
        renderEditor: ({ field }) =>
            (<RegionTypeSelect {...field} autoFocus={true} />)
      }
    }, {
      header: 'Region',
      accessor: 'campaignComponent.region',
      sort: 'campaignComponent.region.name',
      dataType:'select',
      options: {
        label:'name',
        renderEditor: ({ field, row }) => {
          const rt = getObjectByPath(row, 'campaignComponent.regionType');
          return <RegionSelect regionType={rt ? rt.id : null} {...field} autoFocus={true} />;
        }
      }
    }, {
      header: 'Notes',
      accessor: 'name',
      dataType:'text',
    }, {
      header: 'Type',
      accessor: 'ambientType',
      sort: 'ambientType.name',
      dataType:'select',
      options: {
        label:'name',
        renderEditor: ({ field }) => <AmbientTypeSelect {...field} autoFocus={true} />
      }
    }, {
      header: 'Start Date',
      accessor: 'start_date',
      dataType:'date',
      options: {
        renderEditor: ({ field }) => (<IsoDatePicker autoFocus={true} {...field} />)
      }
    },
    {
      header: 'End Date',
      accessor: 'end_date',
      className: 'column-date',
      dataType:'date',
      options: {
        renderEditor: ({field})=><IsoDatePicker autoFocus={true} {...field} />
      }
    }, {
      header: 'Unit Cost',
      accessor: 'campaignComponent.unit_value_local',
      currencyAccessor: 'campaignComponent.currency',
      dataType:'currency',
      readOnly:()=>{return isReadOnly(true)},
      options: {
        currency: {
          allowContextCurrency:true,
          accessor: 'campaignComponent.currency'
        }
      },
      summaries: {
        // eslint-disable-next-line react/display-name
        footer: () => {
          return <b style={{display:'flex',alignItems:'center'}}>Total</b>
        }
      }

    }, {
      header: 'Qty',
      accessor: 'campaignComponent.qty',
      dataType:'number',
      readOnly:()=>{return isReadOnly(true)},
      summaries: {
        footer: ({ rows }) => {
          return rows.reduce((total,current)=> { return total+(parseInt(current.campaignComponent?.qty)||0); },0)
        }
      }
    }, {
      header: 'Total',
      accessor: 'total',
      dataType: 'currency',
      readOnly: true,
      options: {
        getValue: ({ row }) => {
          return row.campaignComponent?.qty*row.campaignComponent?.unit_value_local;
        }
      },
      summaries: {
        footer: ({ rows,currency }) => {
          const defaultCurrency = currency?.id;
          let seenOther = false;
          const value = rows.reduce((total, current) => {
            const cid = current.campaignComponent.currency?.id;
            if(cid && defaultCurrency != cid) {
              seenOther = true;
            }
            return (total + (parseInt(current.campaignComponent?.qty) * parseInt(current.campaignComponent?.unit_value_local)));
          }, 0)
          if(seenOther) return null;
          return variableCurrencyValue({ currency: currency, value: value });
        }
      }
    },{
      header: 'Total Quote',
      accessor: 'total_quote',
      dataType: 'currency',
      hideWhen:({exchangeRateContext})=>{
        return !(exchangeRateContext.options && exchangeRateContext.options.length > 1);
      },
      readOnly: true,
      options: {
        getValue: ({  row, calcExchangeRate }) => {
          if(!row.campaignComponent) return '';
          return calcExchangeRate(row.campaignComponent.currency,row.campaignComponent?.unit_value_local,row.campaignComponent?.qty);
        },
        currency: {
          accessor:'fred'
        }
        /*
        getValue: ({ currency, field, row, calcExchangeRate }) => {
          if(!row.campaignComponent) return '';
          return variableCurrencyValue({ currency: field.currency, value: calcExchangeRate(row.campaignComponent.currency,row.campaignComponent?.unit_value_local,row.campaignComponent?.qty) });
        }*/
      },
      summaries: {
        footer: ({ rows, currency, calcExchangeRate }) => {
          const value = rows.reduce((total, current) => {
            return (total + calcExchangeRate(current.campaignComponent.currency,parseInt(current.campaignComponent?.unit_value_local,10)*parseInt(current.campaignComponent?.qty,10)));
          }, 0)
          return variableCurrencyValue({ currency: currency, value: value });
        }
      }
    }
  ];
  const allowAddDelete = !(readOnly || isReadOnly(true));

  useEffect(()=>{
    setTab('ambients');
  },[]);
  return <FieldTable name="ambients" columns={columns} values={values?.ambients} errors={errors} setValue={setValue} summaries={summaries}
    newRow={newRow} newRowLabel={allowAddDelete?"Add Ambient":null} loading={loading}
                     hasDelete={allowAddDelete}
    className="campaigns__ambients" readOnly={readOnly}
    />;
});

export default AmbientPane;